import React, { useEffect, useRef } from 'react';

function OnlyOfficeEditor() {
    const containerRef = useRef(null);

    useEffect(() => {
        const config = {
            document: {
                fileType: 'docx',
                key: 'test-doc-key-12343', // change this if you reload the file
                title: 'Test Document',
                url: 'https://api.accelgrowth.in/static/1748547429740-test_file.docx'
            },
            documentType: 'word',
            editorConfig: {
                user: {
                    id: 'test-user',
                    name: 'Tester'
                }
            },
            height: '100%',
            width: '100%'
        };

        if (window.DocsAPI) {
            new window.DocsAPI.DocEditor(containerRef.current.id, config);
        }
    }, []);

    return (
        <div
            id="onlyoffice-editor"
            ref={containerRef}
            style={{ height: '80vh', width: '100%', border: '1px solid #ddd' }}
        />
    );
}

export default OnlyOfficeEditor;
